// src/components/AdminRoute.jsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * AdminRoute - Requires admin authentication with custom claims
 * This ensures both frontend and backend security
 */
function AdminRoute({ redirectTo = '/wdalogin', children }) {
  const { currentUser, isAdmin, loading, authInitialized } = useAuth();

  if (loading || !authInitialized) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ backgroundColor: 'var(--bg)' }}
      >
        <div className="text-center">
          <div
            className="w-12 h-12 border-4 border-t-transparent rounded-full animate-spin mx-auto mb-4"
            style={{ borderColor: 'var(--text)' }}
          />
          <p style={{ color: 'var(--muted)' }}>
            Verifying admin credentials...
          </p>
        </div>
      </div>
    );
  }

  if (!currentUser || !isAdmin) {
    return <Navigate to={redirectTo} replace />;
  }

  return children || <Outlet />;
}

export default AdminRoute;
